import { MolsonBox, MolsonSpinner } from '@components/reusable'
import { Fade } from '@mui/material'
import { useEffect, useState } from 'react'

type LoadingSpinnerProps = {
  delay?: boolean
  delayDuration?: number
  isLoading: boolean
}

export const LoadingSpinner = ({
  delay = true,
  delayDuration = 700,
  isLoading
}: LoadingSpinnerProps) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (isLoading && delay) {
      const timeoutId = setTimeout(() => setIsVisible(true), delayDuration)
      return () => clearTimeout(timeoutId)
    }
  }, [isLoading, delay, delayDuration])

  return (
    <Fade in={delay ? isVisible : isLoading} unmountOnExit={true}>
      <MolsonBox
        alignItems="center"
        bgcolor="rgba(0, 0, 0, .2)"
        display="flex"
        height="100%"
        justifyContent="center"
        left="0"
        position="fixed"
        top="0"
        width="100%"
        zIndex={9999}
        data-testid="loading-spinner"
      >
        <MolsonSpinner
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            position: 'fixed'
          }}
          size="5rem"
        />
      </MolsonBox>
    </Fade>
  )
}
